module.exports = __webpack_public_path__ + "static/media/16.d0bf7f0e.svg";